import { render, staticRenderFns } from "./AddModel.vue?vue&type=template&id=6029aff6&scoped=true&"
import script from "./AddModel.vue?vue&type=script&lang=js&"
export * from "./AddModel.vue?vue&type=script&lang=js&"
import style0 from "./AddModel.vue?vue&type=style&index=0&id=6029aff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6029aff6",
  null
  
)

export default component.exports